import { useCallback, useEffect, useState } from 'react';
import type { AxiosError } from 'axios';
import { api } from '../utils/api';
import type { AppDownloadDetail } from '../models/interface/app-download.interface';

type UseAppDownloadDetailResult = {
  appDownloadDetailVersion: any | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
};

export const useAppDownloadDetailVersion = (id?: number | null): UseAppDownloadDetailResult => {
  const [appDownloadDetailVersion, setAppDownloadDetailVersion] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAppDownloadDetailVersion = useCallback(async (): Promise<void> => {
    if (!id) {
      setAppDownloadDetailVersion(null);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await api.get<AppDownloadDetail>(`/api/app/apps/${id}/versions`);
      setAppDownloadDetailVersion(res.data);
    } catch (err) {
      const axiosError = err as AxiosError<{ message?: string }>;
      const message =
        axiosError.response?.data?.message ||
        axiosError.message ||
        'Failed to load app download detail';

      setError(message);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchAppDownloadDetailVersion();
  }, [fetchAppDownloadDetailVersion]);

  return { appDownloadDetailVersion, loading, error, refetch: fetchAppDownloadDetailVersion };
};
